/* eslint-disable */
// @ts-nocheck

import React from "react";
import { FormLabel, MultiSelect, FilterableMultiSelect } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  className?: string;
  titleText?: string;
  placeholder?: string;
  items: Array;
  onChange: (value?: any) => void;
  tooltipText?: string;
  required?: boolean;
  disabled?: boolean;
  selectedItems?: any;
}

const transformSelectedItems = (selectedItems) =>
  selectedItems && !selectedItems.some((obj) => "id" in obj && "text" in obj)
    ? selectedItems.map((row) => ({
        id: row["CHANNEL-ID"],
        text: row["CHANNEL-ID"],
      }))
    : selectedItems;

const MultiselectSearchField = ({
  className,
  titleText,
  placeholder,
  items,
  onChange,
  tooltipText,
  required,
  disabled = false,
  selectedItems,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div className="form-label" data-cy="multiSelectFieldForm">
        <FormLabel data-cy={`${titleText.replaceAll(" ", "")}-textlabel`}>
          {titleText} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${titleText.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
      <FilterableMultiSelect
        className="multiselect-field"
        placeholder={placeholder || titleText}
        items={items}
        itemToString={(item) => (item ? item.text : "")}
        onChange={(e) => {
          onChange(e);
        }}
        initialSelectedItems={selectedItems}
        selectionFeedback="top-after-reopen"
        disabled={disabled}
        required={required}
        data-cy={`${titleText.replaceAll(" ", "")}-input`}
      />
    </div>
  );
};

export default MultiselectSearchField;
